<template>
  <qx-card title="ETC列表">
    <LogRightDialog ref="logRightDialog" busiCode="210010" />
    <MatchDialog ref="matchDialog" @sub="getData" />
    <section slot="titleRight">
      <qx-permpisions permpisions="4000605">
        <el-button type="primary" plain @click="backOrder">反写订单</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="4000612">
        <el-button
          type="primary"
          plain
          @click="deduction(tableData.selectResult)"
          >发起扣费</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions v-show="checkPermpisions('4000611') || checkPermpisions('4000610')">
        <el-dropdown>
          <el-button type="primary" plain>
            上报费用
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              @click.native="postCost(tableData.selectResult, 1)"
              v-if="checkPermpisions('4000611')"
              >覆盖上报费用</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="postCost(tableData.selectResult, 0)"
              v-if="checkPermpisions('4000610')"
              >取消覆盖</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </qx-permpisions>
      <qx-permpisions permpisions="4000602">
        <ImportBtn
          title="导入ETC"
          :isDownloadLocalTemplate="true"
          fileUrl="/file/ETC消费记录导入模板.xlsx"
          :fileData="{
            bizCode: 'imp100080',
            bizName: 'ETC消费明细批量导入',
            id: 23,
          }"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1005040201">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="cmEtcInfoBO.ajax?cmd=doQuery"
          :params="fullSearchData"
          bizName="ETC卡消费记录导出"
          bizCode="exp100049"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'chargingState'">
                  <span v-if="scope.row.chargingState === 0">未扣费</span>
                  <span v-if="scope.row.chargingState === 1">扣费成功</span>
                  <span v-if="scope.row.chargingState === 3">反写成功</span>
                  <el-tooltip :content="scope.row.remark">
                    <span
                      class="cur primary"
                      v-if="scope.row.chargingState === 4"
                      >反写失败</span
                    >
                    <span
                      class="cur primary"
                      v-if="scope.row.chargingState === 2"
                      >扣费失败</span
                    >
                  </el-tooltip>
                  <span v-if="scope.row.chargingState === 5">无需扣费</span>
                </section>
                <section v-if="scope.column.property !== 'chargingState'">
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="210"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '4000604',
                    showCondition: true,
                    name: '手动匹配',
                    event: () => matching(scope.row),
                  },
                  {
                    permpisions: '4000608',
                    showCondition:
                      scope.row.chargingState !== 2 &&
                      scope.row.etcUserType === 1 &&
                      scope.row.paymentWay === 2 &&
                      scope.row.isCover !== 1,
                    name: '覆盖上报费用',
                    event: () => postCost([scope.row], 1),
                  },
                  {
                    permpisions: '4000609',
                    showCondition:
                      scope.row.chargingState !== 2 &&
                      scope.row.etcUserType === 1 &&
                      scope.row.paymentWay === 2 &&
                      scope.row.isCover === 1,
                    name: '取消覆盖',
                    event: () => postCost([scope.row], 0),
                  },
                  {
                    showCondition:
                      scope.row.chargingState === 2 &&
                      scope.row.etcUserType === 1,
                    name: '重新发起扣费',
                    event: () => deduction([scope.row]),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.etcId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  etcConsumeList,
  etcBackOrder, // 反写订单
  etcDeduction, // 扣费
  etcPostCost, // 上报费用
} from 'api/service';
import LogRightDialog from 'components/logRightDialog';
import ImportBtn from 'components/importBtn';
import ExportBtn from 'components/exportBtn';
import MatchDialog from './matchDialog/matchDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ImportBtn,
    ExportBtn,
    MatchDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'etcId',
        title: [ // 表头
          { prop: 'etcCardNo', label: 'ETC卡号', fixed: true },
          { prop: 'etcConsumeTime', label: '消费时间' },
          { prop: 'statementDateStr', label: '账单日期' },
          { prop: 'plateNumber', label: '车牌号' },
          { prop: 'serviceProviderName', label: '服务商' },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'paymentTypeName', label: '付费类型' },
          { prop: 'consumeMoneyDouble', label: '消费金额' },
          { prop: 'consumeAfterMoneyDouble', label: '折后金额' },
          { prop: 'consumeProfitDouble', label: '利润' },
          { prop: 'tradingSite', label: '交易地点' },
          { prop: 'orderId', label: '归属订单' },
          { prop: 'collectName', label: '费用归属人' },
          { prop: 'collectMobile', label: '费用归属人手机' },
          { prop: 'etcUserTypeName', label: '车辆类型' },
          { prop: 'paymentWayName', label: '成本模式' },
          { prop: 'billNo', label: '账单编号' },
          { prop: 'billStartDate', label: '开始日期' },
          { prop: 'billEndDate', label: '结束日期' },
          { prop: 'cutPaymentDay', label: '扣费日期' },
          { prop: 'sourceTypeName', label: '记录来源' },
          { prop: 'matchName', label: '匹配状态' },
          { prop: 'chargingState', label: '扣费状态' },
          { prop: 'isCoverName', label: '覆盖上报' },
          { prop: 'etcMatchTypeName', label: '匹配类型' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: etcConsumeList,
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    async backOrder () { // 反写订单
      if (this.tableData.selectResult.length === 0) {
        this.$message.warning('请先选择操作对象');
        return;
      }
      const confirmRes = await this.$confirm('是否确认反写订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const etcIds = this.tableData.selectResult.map((item) => item.etcId);
        const subRes = await etcBackOrder({ etcIds: etcIds.join(',') });
        if (!subRes.failed) {
          this.$message.success('反写成功');
          this.getData();
        }
      }
    },
    async deduction (arr) { // 扣费
      if (arr.length === 0) {
        this.$message.warning('请先选择操作对象');
        return;
      }
      const confirmRes = await this.$confirm('是否确认发起扣费?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const etcIds = arr.map((item) => item.etcId);
        const subRes = await etcDeduction({ etcIds: etcIds.join(',') });
        if (!subRes.failed) {
          this.$message.success('扣费成功');
          this.getData();
        }
      }
    },
    async postCost (arr, coverType) { // 上报费用
      if (arr.length === 0) {
        this.$message.warning('请先选择操作对象');
        return;
      }
      const confirmRes = await this.$confirm(`是否确认${coverType === 0 ? '取消覆盖费用' : '覆盖上报费用'}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const etcIds = arr.map((item) => item.etcId);
        const subRes = await etcPostCost({
          etcIds: etcIds.join(','),
          coverType,
        });
        if (!subRes.failed) {
          this.$message.success('操作成功');
          this.getData();
        }
      }
    },
    async matching (item) { // 手动选择匹配
      this.$refs.matchDialog.show(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
